import Upgrade from "../upgrade/Upgrade";
import UpgradeCreators from "../upgrade/free/UpgradeCreators";
import BigNumSave from "./BigNumSave";
import BigNum from "../math/BigNum";
import { UpgadeCreatorIds } from "../upgrade/free/UpgradeCreatorIds";
import UpgradeCreator from "../upgrade/free/UpgradeCreator";
import MinedUpgradeCollection from "../upgrade/free/MinedUpgradeCollection";
import MinedUpgrade from "../upgrade/free/MinedUpgrade";
import MinedOreUpgrade from "../upgrade/free/MinedOreUpgrade";

export default class MinedUpgradeCollectionSave {
    constructor() {        
    }

    /**
     * @param {MinedUpgradeCollection} upgradeCollection
     * @returns {Object}
     */
    static generateSave(upgradeCollection) {
        const saveState = {};

        saveState.upgrades = [];

        for (let i = 0; i < upgradeCollection.upgrades.length; i++) {
            if (!upgradeCollection.upgrades[i]) {
                continue;
            }
            saveState.upgrades.push(this.generateUpgradeSave(upgradeCollection.upgrades[i]));
        }

        return saveState;
    }

    /**
     * @param {MinedUpgradeCollection} upgradeCollection
     * @param {UpgradeCreators} upgradeCreators
     * @param {Object} saveState 
     */
    static loadSave(upgradeCollection, upgradeCreators, saveState) {
        if (!saveState) {
            console.log('MinedUpgradeCollectionSave.loadSave no save state');
            return;
        }

        const upgradeSaves = saveState.upgrades;
        if (!upgradeSaves) {
            console.log('MinedUpgradeCollectionSave.loadSave state empty');
            return;
        }

        for (let i = 0; i < upgradeSaves.length; i++) {
            const upgrade = this.loadUpgradeSave(upgradeCreators, upgradeSaves[i]);
            if (upgrade) {
                upgradeCollection.addBulk(upgrade);
            }
        }

        upgradeCollection.addBulkCompleted();
    }

    /**
     * @private
     * @param {Upgrade} upgrade 
     * @returns {Object}
     */
    static generateUpgradeSave(upgrade) {
        const creatorId = upgrade.getCreatorId();

        const saveState = {};
        saveState.creatorId = creatorId;

        if (creatorId === UpgadeCreatorIds.mineDamage) {
            this.generateFreeValueUpgradeSave(upgrade, saveState);
        }
        else if (creatorId === UpgadeCreatorIds.mineOre) {
            this.generateMinedOreUpgradeSave(upgrade, saveState);
        }
        else {
            console.log('MinedUpgradeCollectionSave.generateUpgradeSave() No save logic associated with creatorId: ' + creatorId)
        }

        return saveState;
    }

    /**
     * @private
     * @param {UpgradeCreators} upgradeCreators 
     * @param {Object} upgradeSave 
     * @returns {Upgrade}
     */
    static loadUpgradeSave(upgradeCreators, upgradeSave) {
        if (!upgradeSave) {
            return null;
        }

        const creatorId = upgradeSave.creatorId;
        if (!creatorId) {
            return null;
        }

        const upgradeCreator = upgradeCreators.getUpgradeCreatorById(creatorId);
        if (!upgradeCreator) {
            console.log('MinedUpgradeCollectionSave.loadUpgradeSave() Failed to find upgrade creator ID=' + creatorId);
            return null;
        }

        // The different types of upgrades need to save different stuff:

        if (creatorId === UpgadeCreatorIds.mineDamage) {
            return this.loadFreeValueUpgradeSave(upgradeCreator, upgradeSave);
        }
        else if (creatorId === UpgadeCreatorIds.mineOre) {
            return this.loadMinedOreUpgradeSave(upgradeCreator, upgradeSave);
        }
        else {
            console.log('MinedUpgradeCollectionSave.loadUpgradeSave() No save logic associated with creatorId: ' + creatorId)
            return null;
        }
    }

    /////////////////////////////////////////////////////

    /**
     * @private
     * @param {MinedUpgrade} minedUpgrade 
     * @param {Object} saveState
     */
    static generateFreeValueUpgradeSave(minedUpgrade, saveState) {
        // Lots of upgrades are free.
        if (minedUpgrade.cost) {
            saveState.cost = BigNumSave.save(minedUpgrade.cost);
        }

        saveState.value = BigNumSave.save(minedUpgrade.valueDelta); // valueDelta only exists in the MinedUpgrade object
    }

    /**
     * @private
     * @param {UpgradeCreator} upgradeCreator
     * @param {Object} upgradeSave 
     * @returns {Upgrade}
     */
    static loadFreeValueUpgradeSave(upgradeCreator, upgradeSave) {

        let valueDelta = new BigNum(0);
        BigNumSave.load(upgradeSave.value, valueDelta);

        return upgradeCreator.createFreeValueUpgradeFromSave(valueDelta);
    }

    /**
     * @private
     * @param {MinedOreUpgrade} minedUpgrade 
     * @param {Object} saveState
     */
    static generateMinedOreUpgradeSave(minedUpgrade, saveState) {
        // Lots of upgrades are free.
        if (minedUpgrade.cost) {
            saveState.cost = BigNumSave.save(minedUpgrade.cost);
        }

        saveState.value = BigNumSave.save(minedUpgrade.ore); 
    }
    
    /**
     * @private
     * @param {UpgradeCreator} upgradeCreator
     * @param {Object} upgradeSave 
     * @returns {Upgrade}
     */
    static loadMinedOreUpgradeSave(upgradeCreator, upgradeSave) {

        let valueDelta = new BigNum(0);
        BigNumSave.load(upgradeSave.value, valueDelta);

        return upgradeCreator.createFreeValueUpgradeFromSave(valueDelta);
    }

}